import {isNil, isNumber} from "lodash"

import {LatLng} from "../types"

export const adjustPrecision = ({lat, lng}: LatLng, digits = 6): LatLng | null => {
  if (isNil(lat) || isNil(lng)) { return null }
  return {
    lat: Number(lat.toFixed(digits)),
    lng: Number(lng.toFixed(digits))
  }
}

export const hasValidValues = (lat: any, lng: any): boolean => isNumber(lat) && isNumber(lng)
